module.exports = __webpack_public_path__ + "static/media/ubelens.3f0e9481.jpg";